<template>
    <div class="contact_page page">
        <div class="top_bg">
            <!--            <img src="../assets/partner_bg.png">-->
            <img :src="banner?api+banner:require('../assets/download_bg.png')">
        </div>

        <b-container class="contact_content my_content">
            <p class="title">{{ pageData.name }}</p>


            <div class="text-center" v-if="pageData.content" v-html="pageData.content"></div>
            <!--            <b-row>-->
            <!--                <b-col md="6">-->
            <!--                    <div class="link_item">-->
            <!--                        <p class="sub_title">总部</p>-->
            <!--                        <p class="info">161 Baypointe Pkwy, San Jose, CA 95134, United States</p>-->
            <!--                        <p class="info"> 电话：+1-408-933-1088</p>-->
            <!--                        <p class="info">商务合作：marketing@airdisk.cc</p>-->
            <!--                        <p class="info">售后服务：service@airdisk.cc</p>-->
            <!--                    </div>-->
            <!--                </b-col>-->

            <!--                <b-col md="6">-->
            <!--                    <div class="link_item">-->
            <!--                        <p class="sub_title">总部</p>-->
            <!--                        <p class="info">161 Baypointe Pkwy, San Jose, CA 95134, United States</p>-->
            <!--                        <p class="info"> 电话：+1-408-933-1088</p>-->
            <!--                        <p class="info">商务合作：marketing@airdisk.cc</p>-->
            <!--                        <p class="info">售后服务：service@airdisk.cc</p>-->
            <!--                    </div>-->
            <!--                </b-col>-->
            <!--            </b-row>-->

            <div class="contact_form">
                <b-row class="item">
                    <b-col>
                        <b-form-select v-model="select1" :options="options1"></b-form-select>
                    </b-col>
                    <b-col>
                        <b-form-select v-model="select2" :options="options2"></b-form-select>
                    </b-col>
                </b-row>

                <b-row class="item">
                    <b-col>
                        <b-form-input :placeholder="languageNum == 3?'姓名':'name'"
                                      v-model="formInfo.name"></b-form-input>
                    </b-col>
                    <b-col>
                        <b-form-input :placeholder="languageNum == 3?'国家':'country'"
                                      v-model="formInfo.countries"></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="item">
                    <b-col>
                        <b-form-input :placeholder="languageNum == 3?'手机号':'phone'"
                                      v-model="formInfo.phone"></b-form-input>
                    </b-col>
                    <b-col>
                        <b-form-input :placeholder="languageNum == 3?'邮箱':'email'"
                                      v-model="formInfo.email"></b-form-input>
                    </b-col>
                </b-row>

                <b-row class="item">
                    <b-col>
                        <b-form-textarea
                                id="textarea"
                                :placeholder="languageNum == 3?'输入内容':'content'"
                                rows="6"
                                max-rows="6"
                                v-model="formInfo.content"
                        ></b-form-textarea>
                    </b-col>
                </b-row>

                <div class="more-btn" @click="submitClick()">
                    <div class="box_inner">
                        {{ languageNum == 3 ? '提交' : 'submit' }}
                    </div>
                </div>
            </div>

        </b-container>

        <b-alert class="alert" :variant="showDismissibleAlert==2?'danger':'success'"
                 v-model="showDismissibleAlertStatus">
            {{ showDismissibleAlert == 2 ? 'Error' : 'Success' }}
        </b-alert>

        <b-alert class="alert" :variant="'danger'"
                 v-model="remindDismissibleAlertStatus">
            {{ languageNum == 3 ? '请完善信息' : 'Please complete the information.' }}
        </b-alert>

    </div>
</template>

<script>

    import {singleDetail, getTypeList, consultSubmit} from '../api/HomeService'
    import {api} from '../api/api';

    export default {
        name: "Contact",
        data() {
            return {
                languageNum: window.localStorage.getItem("languageNum"),
                pageData: {},
                formInfo: {
                    name: "",
                    content: "",
                    countries: "",
                    email: "",
                    languageNum: "",
                    mattersId: "",
                    phone: "",
                    addressId: ""
                },
                select1: null,
                select2: null,
                options1: [],
                options2: [],
                banner: '',
                api: api,
                showDismissibleAlert: 0,
                showDismissibleAlertStatus: false,
                remindDismissibleAlertStatus: false
            }
        },
        methods: {

            submitClick() {
                this.formInfo.addressId = this.select2
                this.formInfo.mattersId = this.select1
                this.formInfo.languageNum = this.languageNum

                for (let key in this.formInfo) {
                    if (!this.formInfo[key]) {
                        this.remindDismissibleAlertStatus = true
                        setTimeout(() => {
                            this.remindDismissibleAlertStatus = false
                        }, 3000)
                        return
                    }
                }

                // consultSubmit(this.formInfo)
                consultSubmit(this.formInfo, data => {
                    this.showDismissibleAlertStatus = true
                    setTimeout(() => {
                        this.showDismissibleAlertStatus = false
                    }, 3000)

                    if (data.code === 500) {
                        this.showDismissibleAlert = 2
                        return
                    }
                    this.showDismissibleAlert = 1

                })
            },

            getTypeList() {
                let sendData = {
                    languageNum: this.languageNum,
                    type: 4
                }
                singleDetail(sendData, data => {
                    this.pageData = data[0] || {};
                })


                let sendData2 = {
                    languageNum: this.languageNum,
                    classType: 4
                }
                getTypeList(sendData2, data => {
                    for (let i = 0; i < data.length; i++) {
                        data[i].text = data[i].name
                        data[i].value = data[i].id
                        this.options1.push(data[i])
                    }
                })

                let sendData3 = {
                    languageNum: this.languageNum,
                    classType: 3
                }
                getTypeList(sendData3, data => {
                    for (let i = 0; i < data.length; i++) {
                        data[i].text = data[i].name
                        data[i].value = data[i].id
                        this.options2.push(data[i])
                    }
                })

            }
        },
        mounted() {

            let menuList = JSON.parse(window.localStorage.getItem('menuList'));
            console.log(menuList)
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].children) {
                    for (let j = 0; j < menuList[i].children.length; j++) {
                        if (this.$route.path.indexOf(menuList[i].children[j].menuUrl) > 0) {
                            this.banner = menuList[i].children[j].banner
                        }
                    }
                }

            }

            this.languageNum = window.localStorage.getItem("languageNum");
            this.options1 = [
                {value: null, text: this.languageNum == 3 ? '选择事项' : 'matter'},
            ];
            this.options2 = [
                {value: null, text: this.languageNum == 3 ? '请选择地区' : 'region'},
            ];

            this.getTypeList();
        }
    }
</script>

<style scoped lang="scss" src="../css/contact.scss">

</style>